import React, { useState } from "react";
import styles from "./CheckboxField.module.css";
import { Checkbox } from "antd";

const CheckboxField = ({ customFieldId, initialChecked, label, onToggle, disabled }) => {


  const handleChange = (event) => {
    if (onToggle) {
        onToggle(event.target.checked);
    }
  };

  return (
    <div className={styles.container}>
      <Checkbox
        id={`checkbox-${customFieldId}`}
        className={styles.checkbox}
        onChange={handleChange}
        checked={initialChecked}
        disabled={disabled}
      />
      <label 
        htmlFor={`checkbox-${customFieldId}`} 
        className={`${styles.label} ${disabled ? styles.disabledLabel : ''}`}
      >
        {label}
      </label>
    </div>
  );
};

export default CheckboxField;
